import { IItem } from "./IItem";
import { INameDisplayable, instanceOfINameDisplayable } from "./INameDisplayable";

export interface ITextLengthValidatable extends IItem, INameDisplayable {
  enableLengthCheck: boolean;
  lengthChecklength: number;
  getTextLength(): number;
}

export function instanceOfITextLengthValidatable(instance: any): instance is ITextLengthValidatable {
  if (!instance) { return false; }
  return (instance.enableLengthCheck !== undefined)
    && (instance.lengthChecklength !== undefined)
    && (instance.getTextLength !== undefined)
    && instanceOfINameDisplayable(instance);
}
